module.exports = __webpack_public_path__ + "img/menu-hair-4.f572508e.webp";